import {
  Box,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Paper,
} from "@mui/material";
import React from "react";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseIcon from "@mui/icons-material/Close";
import ChatHeaderActions from "./ChatHeaderActions";
import SparklesIcon from "@mui/icons-material/AutoAwesome";

const ChatTopBar = ({
  toggleFullScreen,
  onClose,
  isFullScreen,
  onAddChat,
  toggleChatsListPanel,
  showAddChat,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        px: 2,
        py: 1,
        borderBottom: "1px solid #eee",
        backgroundColor: "#fff",
        borderRadius: 0,
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Tooltip title={isFullScreen ? "Collapse" : "Expand"}>
            <IconButton size="small" onClick={toggleFullScreen}>
              <OpenInFullIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>

          <SparklesIcon sx={{ fontSize: 20, color: "#444" }} />
          <Chip
            label="BETA"
            size="small"
            sx={{
              height: 22,
              fontSize: 11,
              fontWeight: 500,
              bgcolor: "#000",
              color: "#fff",
              borderRadius: 1,
            }}
          />
        </Stack>

        <Box flex={1} />

        {!isFullScreen && (
          <ChatHeaderActions
            onAddChat={onAddChat}
            toggleChatsListPanel={toggleChatsListPanel}
            showAddChat={showAddChat}
          />
        )}

        <Tooltip title="Close">
          <IconButton size="small" onClick={onClose}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Paper>
  );
};

export default ChatTopBar;
